module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-groningen.svg?c7a0b989b992068b30111fda38d5b880";